<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
      <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
  
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">SO (Outbound)</h4>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
  
                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                    <!-- <button v-if="permision_role.method_read" class="btn btn-dark float-end btn-xs"
                      style="margin-right: 5px" @click="massUploadSo()" type="button">
                      <i class="link-icon mdi mdi-upload"></i>
                      Upload SO .xlsx
                    </button> -->
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-flux-master-sku" ref="list-flux-master-sku"
                      :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: $t('data_selected'), clearSelectionText: $t('clear'), }"
                      mode="remote" @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                        
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
  
                      <div slot="table-actions">
                        {{ $t("no_select_data") }}
                      </div>
                      <div slot="selected-row-actions">
                        <!-- <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs" style="margin-right:20px;"
                          @click="deleteMass">  <i class="mdi mdi-delete"></i>{{ $t("DeleteTxt") }}</button> -->
  
                        <button v-if="permision_role.method_read" class="btn btn-success btn-xs" @click="cancelMass" style="margin-right:20px;"><i class="mdi mdi-close"></i> {{
                            $t("cancel_order_txt")
                        }} </button>

                        <!-- <button class="btn btn-primary btn-xs" @click="submitMass"> 
                          <i class="mdi mdi-send-outline"></i> Submit Order
                        </button> -->
                      </div>

                      <template slot="column-filter" slot-scope="{ column }">
                      
                      <span v-if="column.filterOptions.customFilter">

                        <span v-if="column.field =='orderTime'">

                          <date-range-picker style="width:100%" @update="firstDatesChange" control-container-class="form-control" :locale-data="locale" v-model="firstDates" :opens="'center'" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a @click="clearfirstDatesChange()" class="float-end" style="margin-right: 5px;color:red;">Clear Calendar</a> <span v-if="header.in_selection"> - in selection</span>
                              <br>
                            </div>
                          </date-range-picker>

                        </span>

                       
                      </span>
                      

                    </template>
  
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                            detailData(props.index, props.row)
                            ">
                            <i class="mdi mdi-eye" style="font-size:16px"></i>
  
                          </a>
                          <a href="#" v-if="permision_role.method_update && props.row.orderStatus=='DRAFT'" title="Edit"
                            @click.prevent="editData(props.index, props.row)">
                            <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
  
                          </a>
  
                          <!-- <a href="#" v-if="permision_role.method_delete" title="Delete" @click.prevent="
                            deleteData(props.index, props.row)
                            ">
                            <i class="mdi mdi-trash-can-outline" style="font-size:16px; color:red"></i>
                          </a> -->

                          <a href="#" v-if="permision_role.method_read && props.row.orderStatus=='DRAFT' " title="Cancel" @click.prevent="
                            cancelData(props.index, props.row)
                            ">
                            <i class="mdi mdi-cancel" style="font-size:16px; color:red"></i>
                          </a>
                        </span>
  
                        <span v-else-if="props.column.field == 'status'">
                          <span v-if="props.row.status == 'ACTIVE'" class="badge bg-info">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                          <span v-else class="badge bg-secondary">
                            <h5>{{ props.row.status }}</h5>
                          </span>
                        </span>
  
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::modal-->
          <!-- <modal name="massUploadSo" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
              role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form class="forms-sample" @submit.prevent="submitmassUploadSo" method="POST">
                    <div class="modal-header">
                      <h5 class="modal-title" id="massUploadSo">Upload Excel SO</h5>
                      <button type="button" class="btn-close" aria-label="btn-close"
                        @click.prevent="removeModals()"></button>
                    </div>
                    <div class="modal-body">
                      <div class="mb-3">
                        <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                        <input type="file" class="form-control" readonly ref="filemassUploadSo"
                          @change="handleFilemassUploadSo($event)" required />
  
                        <div v-if="errors.file_data_tariff_master">
                          <div v-for="error in errors.file_data_tariff_master" :key="error" class="alert alert-primary"
                            role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
  
                      </div>
                      <div class="mb-3">
                        <br>
                        <label for="downloadTemplateSo" class="form-label">
                          <a @click="downloadTemplateSo()" style="color: #6571ff;text-decoration: none;">
                            Download Template
                          </a>
                        </label>
                      </div>
                      <div class="mb-3" v-if="errorsDataSoUpload">
                        <div class="table-responsive">
                          <table class="table table-hover">
                            <thead>
                              <th>{{ $t('lineNo') }}</th>
                              <th>{{ $t('statusTxt') }}</th>
                              <th>{{ $t('messageTxt') }}</th>
                            </thead>
                            <tbody>
                              <tr v-for="(errorsDataSo, index) in errorsDataSoUpload" :key="index">
                                <th>{{ errorsDataSo.No }}</th>
                                <th>{{ errorsDataSo.status }}</th>
                                <th>{{ errorsDataSo.message }}</th>
                              </tr>
                            </tbody>
                          </table>
                        </div>
  
  
                      </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                      <button type="button" class="btn btn-secondary"
                        @click.prevent="removeModals()">{{ this.$t("close_txt") }}</button>
                      <button type="submit" class="btn btn-primary" v-if="!errorsDataSoUpload">{{
                        this.$t("UploadTxt") }}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal> -->
          <!--end::modal-->
  
  
  
  
  
  
  
  
  
          <!--begin::modal-->
          <modal name="detailSo" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
              role="dialog">
              <div class="modal-dialog  modal-xl">
                <div class="modal-content">
  
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Detail</h5>
                    <button type="button" class="btn btn-default"  @click.prevent="removeModalsdSo()" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
  
                  <div class="modal-body">
                   
                  </div>
  
  
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModalsdSo()">{{this.$t("close_txt")}}</button>
                  </div>
  
  
                </div>
              </div>
            </div>
          </modal>
          <!--end::modal-->
  
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
    
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  import DateRangePicker from 'vue2-daterange-picker';
  
  export default {
    name: "CmlTarifIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
      DateRangePicker,
    },
    data() {
      return {
        cancelBtn:false,

        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
          },
        locale:{
            format:"yyyy-mm-dd",
        
        },
        highlighted:{

        dates: [ // Highlight an array of dates
            new Date(),
        ],

        },
        dateTimes:'',
        fromDates: {
            startDate: null,
            endDate: null
        },
        firstDates:{
            startDate: null,
            endDate: null
        },
        filterOrderType:[],
        forms: {},
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        idOrderHeaders:[],
        permision_role: [],
        langs: ["id", "en"],
        detailUser: [],
        BAS_SKU_IDs: [],
        detailDivisi: [],
        totalRecords: 0,
        activeFlag : false,
        shelfLifeFlag : false,
        kitFlag : false,
        freePickGift : false,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
       
        columns: [

            {
            label: 'Order No',
            field: "orderNo",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: 'Order No', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "keyup", //only trigger on enter not on keyup
                },
            },


            {
            label: 'Doc No',
            field: "docNo",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: 'Doc No', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "keyup", //only trigger on enter not on keyup
                },
            },

           
        
          {
            label: 'Order Type',
            field: "orderType", 
            filterOptions: {
              customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: "Filter By :", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], 
                trigger: "enter", //only trigger on enter not on keyup
            },

          },

          {
            label: 'Order Time',
            field: "orderTime",
            width: "150px",
            thClass: 'text-center',
            filterOptions: {
              customFilter: true,
              slotFilterField: 'orderTime',
      
            },
          },

          {
            label: 'Order Status',
            field: "orderStatus", 
            filterOptions: {
              customFilter: false,
                enabled: true, // enable filter for this column
                placeholder: "Filter By :", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['CANCELLED','DRAFT','NEW','PACKING','PACKING COMPLETED','SHIPPED','SYNC FAILED'], 
                trigger: "enter", //only trigger on enter not on keyup
            },
          },
  
          

          {
            label: 'Warehouse ID',
            field: "warehouseId",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: 'Order No', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },

          {
            label: 'Customer ID',
            field: "customerId",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: 'Order No', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
  

          {
          label: 'Consignee Name',
            field: "consigneeName",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: '', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
  
          {
          label: 'Consignee Street',
            field: "consigneeStreet",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: '', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
  
          {
            label: this.$t("action_txt"),
            field: "actions",
            thClass: 'text-center',
            sortable: false,
            filterOptions: {
              customFilter: false,
            }
          },
        ],
        rows: [],
        rowsSelection: [],
        filemassUploadSo: '',
        errorsDataSoUpload: false,
      };
    },
    watch: {},
    methods: {
  
  
      handleFilemassUploadSo(event) {
        this.filemassUploadSo = event.target.files[0];
      },
  
      massUploadSo() {
        this.$modal.show('massUploadSo')
      },
  
  
      removeModalsdSo() {
        this.$modal.hide('detailSo')
      },
  
      removeModals() {
        this.$modal.hide('massUploadSo')
        this.filemassUploadSo = ""
        this.errorsDataSoUpload = false
        this.loadItems();
  
      },

      fromDatesChange(){

      if(this.fromDates.startDate && this.fromDates.endDate){
          // this.effectiveFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
          // this.effectiveToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
          // this.loadItems()
      }

      },

      firstDatesChange(){
            if(this.firstDates.startDate){
                // this.firstBilingDate=this.$moment(String(this.firstDates.startDate)).format('YYYY-MM-DD')+"~"+this.$moment(String(this.firstDates.endDate)).format('YYYY-MM-DD');
                // this.loadItems()
            }

        },


      clearfirstDatesChange(){
        this.firstDates={
            startDate: null,
            endDate: null
        };
      },
  
      resetForm() {
        this.filemassUploadSo = ""
      },
  
      downloadTemplateSo() {
        //var params = this.$onBehind(this.$route.params.id);
        const baseURI = this.$settings.endPointFluxOms + "v2/sku/index";
        var file_name = "flux-template-master-sku.xlsx";
  
        return this.$http
          .get(
              baseURI +
              `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&orderType=${this.serverParams.columnFilters.orderType}&sku=${this.serverParams.columnFilters.sku}&activeFlag=${this.serverParams.columnFilters.activeFlag}&skuDescr1=${this.serverParams.columnFilters.skuDescr1}&download=downloadTemplate`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
  
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
  
      submitmassUploadSo() {
        this.isLoading = true;
  
        let formData = new FormData();
        formData.append("file", this.filemassUploadSo);
  
        const baseURI = this.$settings.endPointFluxOms + "v2/sku/mass-upload";
        this.$http.post(baseURI, formData).then((response) => {
          this.isLoading = false;
          this.errorsDataSoUpload = response.data.datas;
          this.resetForm();
        }).catch((error) => {
          this.loading();
  
  
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
  
          } else {
  
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsDataSoUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else {
                this.$router.push('/page-not-found');
              }
            }
  
          }
        });
  
      },
  
  
      selectionChanged(ev) {
        console.log(ev);
        this.rowsSelection = [];
        this.idOrderHeaders = [];
        this.rowsSelection = ev.selectedRows;
  
        this.rowsSelection.forEach((item) => {
              if (item.orderStatus == "DRAFT" || item.orderStatus == "SYNC FAILED") {
                this.idOrderHeaders.push(item.idOrderHeader);
              }

           

         
  
        });

        console.log(this.idOrderHeaders);
  
      },
  
      deleteMass() {
  
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataSend"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            //this.loadingSubmiting();
            this.loading();
            let data = {
              idOrderHeaders: this.idOrderHeaders
            }
            const baseURI =
              this.$settings.endPointFluxOms + "v2/so/mass-delete";
            this.$http
              .post(baseURI, data)
              .then((response) => {
                //this.loading();
                this.success(response.data.datas.messages);
                this.idTarifMasterHeader = []
                this.loadItems();
              })
              .catch((error) => {
                this.loading();
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }
  
                }
              });
          } else {
            this.isLoading = false;
          }
        });
  
      },

      cancelMass() {
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          //this.loadingSubmiting();
          this.loading();
          let data = {
            idOrderHeaders: this.idOrderHeaders
          }
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/cancels";
          this.$http
            .patch(baseURI, data)
            .then((response) => {
              //this.loading();
              this.success(response.data.datas.messages);
           
              this.loadItems();
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {

                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });

    },



    submitMass() {
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          //this.loadingSubmiting();
          this.loading();
          let data = {
            orderStatus       : "NEW",
            idOrderHeaders: this.idOrderHeaders
          }
          const baseURI =
            this.$settings.endPointFluxOms + "v2/so/update-status-order-mass";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
              this.success(response.data.datas.messages);
           
              this.loadItems();
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {

                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });

    },
  
      removeSku() {
        this.idTarifMasterHeader = [];
        this.$refs['list-flux-master-sku'].unselectAllInternal()
      },
  
      downloadData() {
        const baseURI = this.$settings.endPointFluxOms + "v2/so/index";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
  
        return this.$http
          .get(
            baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&orderType=${this.serverParams.columnFilters.orderType}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=${this.serverParams.columnFilters.customerId}&orderNo=${this.serverParams.columnFilters.orderNo}&consigneeName=${this.serverParams.columnFilters.consigneeName}&consigneeStreet=${this.serverParams.columnFilters.consigneeStreet}&download=download`,
  
            {
              responseType: "blob",
            }
          )
          .then((response) => {
  
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
  
      createData() {
        window.location.href = "/flux-oms/so-outbound/create";
      },
  
  
      editData(index, row) {
        var params = this.$onRandom(row.idOrderHeader);
        window.location.href = "/flux-oms/so-outbound/edit/" + params;
      },
  
      detailData(index, row) {
        // this.forms = row;
        // this.forms.shelf_life_type_name = row.shelf_life_type[0]["name"];
        // this.activeFlag = this.forms.activeFlag == 'Y' ? true : false;
        // this.shelfLifeFlag = this.forms.shelfLifeFlag == 'Y' ?  true : false;
        // this.kitFlag = this.forms.kitFlag == 'Y' ? true: false;
        // this.freePickGift = this.forms.freePickGift == 'Y' ? true: false;
        // this.$modal.show('detailSo');
        var params = this.$onRandom(row.idOrderHeader);
        window.location.href = "/flux-oms/so-outbound/detail/" + params;
      },
  
      deleteData(index, row, status) {
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataDelete"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            var formData = {
              status: status,
            };
            const baseURI =
              this.$settings.endPointFluxOms + "v2/so/delete/" + row.BAS_SKU_ID;
            this.$http
              .delete(baseURI, formData, { timeout: 10000 })
              .then((response) => {
                this.loading();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);
                  this.loadItems();
                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              }).catch((error) => {
                this.loading();
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
              });
          } else {
            this.isLoading = false;
          }
        });
      },


      cancelData(index, row) {
        this.fade(true);
        this.$swal({
          title: this.$t("areYouSure"),
          text: this.$t("yourDataCancel"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.value) {
            const baseURI =
              this.$settings.endPointFluxOms + "v2/so/cancelled/" + row.idOrderHeader;
            this.$http
              .get(baseURI, { timeout: 10000 })
              .then((response) => {
                this.loading();
                if (response.data.status === 200) {
                  this.success(response.data.datas.messages);
                  this.loadItems();
                } else {
                  this.errors = response.data.errors;
                  this.resultError(response.data.errors);
                }
              }).catch((error) => {
                this.loading();
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
              });
          } else {
            this.isLoading = false;
          }
        });
      },
  
      // load items is what brings back the rows from server
      loadItems() {
        const baseURI = this.$settings.endPointFluxOms + "v2/so/index";
        this.isLoading = true;
        var dateTime=this.dateTimes;
        return this.$http
          .get(
            baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&orderStatus=${this.serverParams.columnFilters.orderStatus}&orderType=${this.serverParams.columnFilters.orderType}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=${this.serverParams.columnFilters.customerId}&orderNo=${this.serverParams.columnFilters.orderNo}&docNo=${this.serverParams.columnFilters.docNo}&orderTime=${dateTime}&consigneeName=${this.serverParams.columnFilters.consigneeName}&consigneeStreet=${this.serverParams.columnFilters.consigneeStreet}`,
            { timeout: 120000 })
          .then((response) => {
            this.isLoading = false;
            this.rows = response.data.datas.data;
            let i = 0;
            for (i = 0; i < 10; i++) {
              if (this.rows[i].orderStatus != "DRAFT") {
                this.$set(this.rows[i], 'vgtDisabled', true);
                this.$set(this.rows[i], 'vgtSelected', false);
              }

              if (this.rows[i].orderStatus == "SYNC FAILED") {
                this.$set(this.rows[i], 'vgtDisabled', false);
                // this.$set(this.rows[i], 'vgtSelected', true);
              }

              
            }

            this.totalRecords = response.data.datas.total;
          }).catch((error) => {
            this.loading();
  
            if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
  
            } else {
  
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push('/server-error');
                } else {
                  this.$router.push('/page-not-found');
                }
              }
  
            }
          });
      },


      loadFilterType() {
        const baseURI = this.$settings.endPointFluxOms + "additional/get-data-wms-code?type=SO_TYP&limit=-1";
        this.isLoading = true;
  
        return this.$http
          .get(
            baseURI,
            { timeout: 10000 })
          .then((response) => {
         
            for (let index = 0; index < response.data.datas.data.length; index++) {
               
                const name=response.data.datas.data[index]['code'];
                // const code = response.data.datas.data[index]['code'];
                this.columns[2].filterOptions.filterDropdownItems.push(name);
                //this.filterOrderType.push({ value: code, text: name});
            }
            console.log(this.filterOrderType);
            // this.isLoading = false;
            // this.rows = response.data.datas.data;
            // this.totalRecords = response.data.datas.total;
          }).catch((error) => {
            // this.loading();
  
            if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
  
            } else {
  
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push('/server-error');
                } else {
                  this.$router.push('/page-not-found');
                }
              }
  
            }
          });
      },
  
      updateParams(newProps) {
      
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.loadItems();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000); // hide the message after 3 seconds
      },
  
      fetchIt() {
        const userDatas = this.$getUserInfo();
        this.detailUser = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function (permision) {
          if (permision.permission.controller == 'SoController') {
            rolePermision = permision;
          }
        });
  
        if (!rolePermision.method_read) {
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },
  
  
      logout() {
  
        const baseURI = this.$settings.endPoint + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
  
          console.log(response);
  
        });
  
        this.$logoutUser();
        window.location.href = '/';
      },
    },
    events: {},
    created: function () { },
    
    mounted() {
      this.loadFilterType();
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  .blur-content {
    filter: blur(5px);
  }
  </style>